import React from "react";
import {
  IconFE,
  CardLatestDeliveries,
  ContainerDescription,
  IconContainer,
  IconContainerAction,
  IconFA5,
  StatusDelivery,
  TitleDelivery,
} from "./styles";

interface CardRoutesProps {
  title: any;
  status: string;
  onPress: () => void;
  first?: boolean;
}

export default function CardDrivers({
  title,
  status,
  onPress,
  first,
}: CardRoutesProps) {
  return (
    <CardLatestDeliveries first={first}>
      <IconContainer>
        <IconFA5 name="user" size={25} />
      </IconContainer>
      <ContainerDescription>
        <TitleDelivery>{title}</TitleDelivery>
        <StatusDelivery>{status}</StatusDelivery>
      </ContainerDescription>
      <IconContainerAction onPress={onPress}>
        <IconFE name="arrow-right" size={25} />
      </IconContainerAction>
    </CardLatestDeliveries>
  );
}
